
export default (
  {
    pnr,
    eventCategory,
    departureRoute,
    ticketNumber,
    SPID,
    totalPassengers,
  }) => {
  return {
    event: 'B2BC',
    eventAction: 'B2BCMessaging',
    eventCategory: eventCategory,
    eventLabel: 'WEB-MYB',
    departureRoute: departureRoute,
    pnr: pnr,
    ticketNumber: ticketNumber,
    SPID: SPID,
    totalPassengers: totalPassengers,
  };
};